const REFRESH_KEY = "udip.refresh";

let accessToken: string | null = null;

/**
 * Access token lives in memory (cleared on reload — the guard re-hydrates via
 * `/auth/refresh`). Refresh token in `localStorage`. When the backend gains an
 * httpOnly-cookie refresh flow this whole module is the only thing that changes.
 */
export const tokenStore = {
  getAccess: () => accessToken,
  getRefresh: () => safeLocalStorage.getItem(REFRESH_KEY),
  set(access: string, refresh?: string | null) {
    accessToken = access;
    if (refresh) safeLocalStorage.setItem(REFRESH_KEY, refresh);
  },
  clear() {
    accessToken = null;
    safeLocalStorage.removeItem(REFRESH_KEY);
  },
  /** ms until the access token expires, or null if unknown. */
  msUntilExpiry(): number | null {
    if (!accessToken) return null;
    const exp = decodeExp(accessToken);
    return exp == null ? null : exp * 1000 - Date.now();
  },
};

function decodeExp(jwt: string): number | null {
  try {
    const payload = jwt.split(".")[1];
    if (!payload) return null;
    const json = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return typeof json.exp === "number" ? json.exp : null;
  } catch {
    return null;
  }
}

/** localStorage throws in some sandboxed contexts; degrade gracefully. */
const safeLocalStorage = {
  getItem(k: string): string | null {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  },
  setItem(k: string, v: string) {
    try {
      localStorage.setItem(k, v);
    } catch {
      /* ignore */
    }
  },
  removeItem(k: string) {
    try {
      localStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  },
};
